import { useState } from "react";
import { toast } from "sonner";
import { Download, Eye, FileText, FileType2, RefreshCw, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { aiApi, absUrl } from "./aiApi";

const kb = (n) => (n ? `${Math.max(1, Math.round(n / 1024))} KB` : "");

export default function AIDocFilesCard({ files, jobId, onRegenerated }) {
  const [view, setView] = useState(null);
  const [busy, setBusy] = useState(false);
  const regen = async () => {
    setBusy(true);
    try { onRegenerated && onRegenerated(await aiApi.regenDoc(jobId)); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal jana semula"); } finally { setBusy(false); }
  };
  return (
    <div className="mt-2 space-y-1.5 max-w-[360px]" data-testid="ai-doc-files-card">
      {files.map((f) => {
        const Icon = f.format === "pdf" ? FileText : FileType2;
        return (
          <div key={f.id} className="flex items-center gap-2 rounded-2xl border border-slate-100 bg-slate-50/70 p-2" data-testid={`ai-doc-file-${f.format}`}>
            <span className={`h-9 w-9 shrink-0 rounded-xl grid place-items-center ${f.format === "pdf" ? "bg-rose-100 text-rose-600" : "bg-sky-100 text-sky-600"}`}><Icon className="h-4.5 w-4.5" /></span>
            <span className="min-w-0 flex-1">
              <span className="block text-[12px] font-semibold text-slate-700 truncate">{f.filename}</span>
              <span className="block text-[10.5px] text-slate-400 uppercase font-bold">{f.format === "pdf" ? "PDF" : "Word"} · {kb(f.size)}</span>
            </span>
            {f.format === "pdf" && (
              <button onClick={() => setView(f)} className="h-8 px-2.5 rounded-full bg-white border border-slate-200 text-[11px] font-semibold text-slate-600 inline-flex items-center gap-1 hover:bg-slate-50" data-testid={`ai-doc-preview-${f.format}`}><Eye className="h-3.5 w-3.5" /> Pratonton</button>
            )}
            <a href={`${absUrl(f.url)}&download=1`} className="h-8 px-2.5 rounded-full bg-gradient-to-r from-pink-500 to-amber-400 text-white text-[11px] font-bold inline-flex items-center gap-1" data-testid={`ai-doc-download-${f.format}`}><Download className="h-3.5 w-3.5" /> Muat Turun</a>
          </div>
        );
      })}
      {jobId && (
        <button onClick={regen} disabled={busy} className="h-7 px-2.5 rounded-full border border-slate-200 bg-white text-[11px] font-semibold text-slate-600 inline-flex items-center gap-1 hover:bg-slate-50 disabled:opacity-50" data-testid="ai-doc-regenerate">
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <RefreshCw className="h-3.5 w-3.5" />} Jana Semula
        </button>
      )}
      <Dialog open={!!view} onOpenChange={(o) => !o && setView(null)}>
        <DialogContent className="z-[10002] sm:max-w-3xl w-[95vw] h-[85vh] rounded-3xl flex flex-col p-3" data-testid="ai-doc-preview-dialog">
          <DialogHeader><DialogTitle className="text-sm truncate pr-6">{view?.filename}</DialogTitle></DialogHeader>
          {view && <iframe title="pratonton" src={absUrl(view.url)} className="flex-1 w-full rounded-xl border border-slate-100" data-testid="ai-doc-preview-frame" />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
